import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ServicePackageRevisionFragmentFragmentDoc } from '../fragments/servicePackageRevision.generated';
import { ServicePackageFragmentFragmentDoc } from '../fragments/servicePackage.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveServicePackageRevisionMutationVariables = Types.Exact<{
  input: Types.SaveServicePackageRevisionInput;
  store_uuid?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type SaveServicePackageRevisionMutation = { __typename?: 'Mutation', saveServicePackageRevision: { __typename?: 'SaveServicePackageRevisionResult', revision: { __typename?: 'ServicePackageRevision', id: string, revision_number: number, min_contract_term_months: number, monthly_service_fee_in_cents: number, onboarding_fee_in_cents: number, ops_order_price_in_cents: number, note?: string | null, created_at: string, created_by?: string | null, allowances: Array<{ __typename?: 'ServicePackageAssetAllowance', id: string, monthly_quantity: number, item: { __typename?: 'ItemType', id: number, name: string } }>, free_checkouts: Array<{ __typename?: 'ServicePackageFreeCheckout', id: string, segment: Types.ContainerTypeSegment, amount: number }> }, package: { __typename?: 'ServicePackage', id: string, package_type: Types.ServicePackageType, currency: string, created_at: string, revisions: Array<{ __typename?: 'ServicePackageRevision', id: string, revision_number: number, min_contract_term_months: number, monthly_service_fee_in_cents: number, onboarding_fee_in_cents: number, ops_order_price_in_cents: number, note?: string | null, created_at: string, created_by?: string | null, allowances: Array<{ __typename?: 'ServicePackageAssetAllowance', id: string, monthly_quantity: number, item: { __typename?: 'ItemType', id: number, name: string } }>, free_checkouts: Array<{ __typename?: 'ServicePackageFreeCheckout', id: string, segment: Types.ContainerTypeSegment, amount: number }> }> } } };


export const SaveServicePackageRevisionDocument = gql`
    mutation saveServicePackageRevision($input: SaveServicePackageRevisionInput!, $store_uuid: ID) {
  saveServicePackageRevision(input: $input, store_uuid: $store_uuid) {
    revision {
      ...ServicePackageRevisionFragment
    }
    package {
      ...ServicePackageFragment
    }
  }
}
    ${ServicePackageRevisionFragmentFragmentDoc}
${ServicePackageFragmentFragmentDoc}`;
export type SaveServicePackageRevisionMutationFn = Apollo.MutationFunction<SaveServicePackageRevisionMutation, SaveServicePackageRevisionMutationVariables>;

/**
 * __useSaveServicePackageRevisionMutation__
 *
 * To run a mutation, you first call `useSaveServicePackageRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveServicePackageRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveServicePackageRevisionMutation, { data, loading, error }] = useSaveServicePackageRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      store_uuid: // value for 'store_uuid'
 *   },
 * });
 */
export function useSaveServicePackageRevisionMutation(baseOptions?: Apollo.MutationHookOptions<SaveServicePackageRevisionMutation, SaveServicePackageRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveServicePackageRevisionMutation, SaveServicePackageRevisionMutationVariables>(SaveServicePackageRevisionDocument, options);
      }
export type SaveServicePackageRevisionMutationHookResult = ReturnType<typeof useSaveServicePackageRevisionMutation>;
export type SaveServicePackageRevisionMutationResult = Apollo.MutationResult<SaveServicePackageRevisionMutation>;
export type SaveServicePackageRevisionMutationOptions = Apollo.BaseMutationOptions<SaveServicePackageRevisionMutation, SaveServicePackageRevisionMutationVariables>;